module.exports = __webpack_public_path__ + "media/application/images/svgs/phone-forwarded-bbf704abbcec246bfd67c0acc7bb554a.svg";